import { forwardRef } from 'react'

import { IconProps, IconVariants } from '../IconVariants'
const ChevronRightIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size, ...props }, ref) => {
  return (
    <svg
      aria-hidden="true"
      className={IconVariants({
        class: className,
        size,
      })}
      fill="none"
      height="1em"
      ref={ref}
      viewBox="0 0 24 24"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path clipRule="evenodd" d="M8 16.59L12.9447 12L8 7.41L9.52227 6L16 12L9.52227 18L8 16.59Z" fill="currentColor" fillRule="evenodd" />
    </svg>
  )
})
ChevronRightIcon.displayName = 'ChevronRightIcon'
export default ChevronRightIcon
